// Mock data
import MicroAuth from "../../fetch/microAuth";

export const sendMail = async ({ email }) => {
  const body = {
    query: `
    mutation {
      sendLink(
        email: "${email}"
        link: "http://${window.location.host}/reset/verify"
      )
    }
    `
  };
  try {
    const resp = await MicroAuth({
      body: JSON.stringify(body)
    });
    // console.log("resp", resp);
    if (resp.data.sendLink) {
      return { data: resp, message: "" };
    } else {
      // console.log("ELSE", resp.errors[0].message);
      return { data: null, message: resp.errors[0].message };
    }
  } catch (err) {
    console.log("errrrr", err);
    return err;
  }
};

export const newPassword = async ({ pass }) => {
  const body = {
    query: `
    mutation{
      updateLink(
      newPassword:"${pass.pass}"
      token:"${pass.token}"
      ){
      id
      entityId
      name
      email
      picture
      mobile
      role
      hasPassword
      }
    }
    `
  };
  try {
    const resp = await MicroAuth({
      body: JSON.stringify(body),
      token: ""
    });
    // console.log("resp", resp);
    if (resp.data.updateLink) {
      return { data: resp.data.updateLink, message: "" };
    } else {
      // console.log("ELSE", resp.errors[0].message);
      return { data: null, message: resp.errors[0].message };
    }
  } catch (err) {
    console.log("errrrr", err);
    return err;
  }
};
